// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file nodebase/v1/billing.proto (package nodebase.v1, syntax proto3)
/* eslint-disable */

import { BillingService } from "./billing_pb";

/**
 * @generated from rpc nodebase.v1.BillingService.GetBillingStatus
 */
export const getBillingStatus = BillingService.method.getBillingStatus;

/**
 * CreateCheckoutSession reserves one paid slot in the Workspace's region and
 * returns the hosted payment page. A full region answers with the
 * paid-capacity-full reason and records the owner's interest instead.
 *
 * @generated from rpc nodebase.v1.BillingService.CreateCheckoutSession
 */
export const createCheckoutSession = BillingService.method.createCheckoutSession;

/**
 * CreateBillingPortalSession opens the processor's self-service page for an
 * owner who has subscribed before: card, invoices, cancellation.
 *
 * @generated from rpc nodebase.v1.BillingService.CreateBillingPortalSession
 */
export const createBillingPortalSession = BillingService.method.createBillingPortalSession;
